import React from 'react';
import { useTranslation } from 'react-i18next';

const Service: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#0A4A7A] mb-12">{t('services.serviceTitle')}</h1>
        
        <section className="mb-16">
          <div className="bg-gray-50 rounded-lg p-8">
            <p className="text-gray-700 mb-6">{t('services.serviceDesc')}</p>
            <div>
              <h3 className="text-xl font-semibold mb-4 text-[#0A4A7A]">{t('services.serviceServices')}</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>{t('services.parkoppling')}</li>
                <li>{t('services.byteFilter')}</li>
                <li>{t('services.grundligRengoring')}</li>
                <li>{t('services.omprogrammering')}</li>
              </ul>
            </div>
          </div>
        </section>

        <div className="text-center bg-[#0A4A7A] rounded-lg p-8">
          <h3 className="text-2xl font-semibold mb-4 text-white">{t('services.bookTitle')}</h3>
          <p className="text-gray-200 mb-6">{t('services.serviceBookDesc')}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:072-334 47 74" className="bg-white text-[#0A4A7A] px-6 py-3 rounded font-semibold hover:bg-gray-100 transition-colors">
              {t('services.call')} 072-334 47 74
            </a>
            <a href="https://www.bokadirekt.se/places/varmdo-horsel-134414" target="_blank" rel="noopener noreferrer" className="border border-white text-white px-6 py-3 rounded font-semibold hover:bg-white/10 transition-colors">
              {t('services.bookTime')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
